
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, Menu, MenuItem, Button, Link } from '@mui/material';
import React from 'react';
import { IQuestion } from '../types';

interface ItemMenuProps {
    item: IQuestion;
}

export const ItemMenu = (props: ItemMenuProps) => {

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const handleSelectedMenu = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const iconButtonStyle = {
        color: "#666 !important",
        transform: "translateY(1%)",
        "&:hover": { color: "#000 !important", cursor: "pointer" }
    }


    return (
        <>
            <IconButton
                title="scribble"
                aria-label="Example"
                sx={iconButtonStyle}
                color="secondary"
                onClick={handleSelectedMenu}
            >
                <MoreVertIcon />

            </IconButton>

            <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={(event: React.MouseEvent<HTMLElement>) => {
                    event.stopPropagation();
                    setAnchorEl(null);
                }}
            >

                {/* <MenuItem>
                    <Button
                        variant="outlined"
                        startIcon={<FavoriteIcon />}
                        onClick={() => { addSelectedToAlbum(); clearSelected(); }}
                        aria-label="album"
                        color="inherit" >
                        Add to favourites
                    </Button>
                </MenuItem> */}

                <MenuItem >
                    <Link href={props.item.qp_pdf_url} target="_blank">
                        question PDF
                    </Link>
                </MenuItem>

                <MenuItem >
                    <Link href={props.item.ms_pdf_url} target="_blank">
                        mark scheme PDF
                    </Link>
                </MenuItem>
            </Menu>
        </>
    )
}